export const BASE_URL = 'https://seniorthrive.com';
